export var defaultProps = {
  typography: "xsmall3"
};